import { render, staticRenderFns } from "./Fuente-alta.vue?vue&type=template&id=3acf5c33"
import script from "./Fuente-alta.vue?vue&type=script&lang=js"
export * from "./Fuente-alta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports